class SectorRepository {
  constructor(api) {
    this.api = api;
  }

  async checkIfEmpty(ID_SECTOR) {
    const raw = `SELECT EXISTS (SELECT * FROM CROP.CAD_SECTOR WHERE ID_SECTOR = ${ID_SECTOR}) as isExists;`;

    const resp = await this.api.sql({
      data: {
        sql: raw
      }
    });

    if (resp.length && resp[0].length) {
      let result = resp[0][0];
      return "isExists" in result ? result.isExists : 0;
    }
    return;
  }
  async getSectorFromNewsirByName(NAME) {
    const raw = `SELECT ID, NAME FROM NEWSIR.CAD_SECTOR
    WHERE NAME = "${NAME}";`;

    const cad_sector_newsir = await this.api.sql({
      data: {
        sql: raw
      }
    });

    return cad_sector_newsir[0][0];
  }
  async getSectorFromNewsirById(ID_SECTOR) {
    const raw = `SELECT ID,NAME,AREA,PLANTING_TYPE, PLANTING_DATE, FLOW, NOTE FROM NEWSIR.CAD_SECTOR
    WHERE ID = ${ID_SECTOR};`;

    const cad_sector_newsir = await this.api.sql({
      data: {
        sql: raw
      }
    });

    if (
      cad_sector_newsir.length &&
      cad_sector_newsir[0] &&
      cad_sector_newsir[0][0]
    ) {
      return cad_sector_newsir[0][0];
    }
    return {};
  }
  async deleteById(ID_SECTOR) {
    const raw = `
      DELETE FROM CROP.CAD_SECTOR WHERE ID_SECTOR = ${ID_SECTOR};
    `;

    const resp = await this.api.sql({
      data: {
        sql: raw
      }
    });
    return resp;
  }
  async showBySectorId(ID) {
    const raw = `
      SELECT
        ID,
        ID_SECTOR,
        DATE_CROP,
        VOLUME_DATE,
        OFFSET_DAP,
        IF(IS_MANAGEMENT=1,true,false) AS IS_MANAGEMENT,
        PRESSURIZE_TIME,
        TIME_ADVANCE,
        AVG_TIME_PULSE,
        APPLICATION_RATE,
        SYSTEM_EFFICIENCY,
        SPACING_BETWEEN_PLANTS,
        SPACING_BETWEEN_LINES,
        ID_SOIL,
        ID_FARM,
        INITIAL_STORAGE
        FROM CROP.CAD_SECTOR WHERE ID_SECTOR = ${ID};
        `;

    const resp = await this.api.sql({
      data: {
        sql: raw
      }
    });

    return resp;
  }
  async update(sector) {
    const {
      ID_SECTOR,
      DATE_CROP,
      VOLUME_DATE,
      OFFSET_DAP,
      IS_MANAGEMENT,
      PRESSURIZE_TIME,
      TIME_ADVANCE,
      AVG_TIME_PULSE,
      APPLICATION_RATE,
      SYSTEM_EFFICIENCY,
      ID_SOIL,
      ID_FARM,
      SPACING_BETWEEN_LINES,
      SPACING_BETWEEN_PLANTS,
      INITIAL_STORAGE
    } = sector;

    const raw = `
    UPDATE CROP.CAD_SECTOR
      SET ID_SECTOR=${ID_SECTOR},
      DATE_CROP="${DATE_CROP}",
      VOLUME_DATE="${VOLUME_DATE}",
      OFFSET_DAP=${OFFSET_DAP},
      IS_MANAGEMENT=${IS_MANAGEMENT},
      PRESSURIZE_TIME=${PRESSURIZE_TIME},
      TIME_ADVANCE=${TIME_ADVANCE},
      AVG_TIME_PULSE=${AVG_TIME_PULSE},
      APPLICATION_RATE= ${APPLICATION_RATE},
      SYSTEM_EFFICIENCY=${SYSTEM_EFFICIENCY},
      ID_SOIL=${ID_SOIL},
      ID_FARM=${ID_FARM},
      SPACING_BETWEEN_LINES=${SPACING_BETWEEN_LINES},
      SPACING_BETWEEN_PLANTS=${SPACING_BETWEEN_PLANTS},
      INITIAL_STORAGE=${INITIAL_STORAGE}
      WHERE ID_SECTOR = ${ID_SECTOR};
      `;

    const resp = await this.api.sql({
      data: {
        sql: raw
      }
    });

    return resp;
  }
  async updateFkEditor(ID_SECTOR,FK_EDITOR){
    const raw = `
      UPDATE NEWSIR.CAD_SECTOR
      SET FK_EDITOR = ${FK_EDITOR}
      WHERE ID = ${ID_SECTOR};
    `
    const resp = await this.api.sql({
      data:{
        sql: raw
      }
    })

    return resp
  }

  async getAllEditors(){
    const raw = `
      SELECT DISTINCT (C_USER.NAME) FROM NEWSIR.CAD_SECTOR AS CS
      INNER JOIN NEWSIR.CAD_USER AS C_USER
      ON CS.FK_EDITOR = C_USER.ID
      ORDER BY C_USER.NAME  DESC
    `;

    const resp = await this.api.sql({
      data: {
        sql: raw
      }
    });

    return resp.length && resp[0];
  }

  async show() {
    const raw = `
        SELECT
          *
        FROM CROP.CAD_SECTOR;
      `;

    const resp = await this.api.sql({
      data: {
        sql: raw
      }
    });

    return resp;
  }
  async save(sector, newsir_sector) {
    const {
      ID_SECTOR,
      DATE_CROP,
      VOLUME_DATE,
      IS_MANAGEMENT,
      OFFSET_DAP,
      PRESSURIZE_TIME,
      TIME_ADVANCE,
      AVG_TIME_PULSE,
      APPLICATION_RATE,
      SYSTEM_EFFICIENCY,
      ID_SOIL,
      ID_FARM,
      SPACING_BETWEEN_LINES,
      SPACING_BETWEEN_PLANTS,
      INITIAL_STORAGE
    } = sector;

    const raw = `
    INSERT INTO CROP.CAD_SECTOR(
      ID_SECTOR,
      DATE_CROP,
      VOLUME_DATE,
        OFFSET_DAP,
        IS_MANAGEMENT,
        PRESSURIZE_TIME,
        TIME_ADVANCE,
        AVG_TIME_PULSE,
        APPLICATION_RATE,
        SYSTEM_EFFICIENCY,
        ID_SOIL,
        ID_FARM,
        INITIAL_STORAGE,
        SPACING_BETWEEN_LINES,
        SPACING_BETWEEN_PLANTS
      )VALUES(
        ${newsir_sector.ID},
        "${DATE_CROP}",
        "${VOLUME_DATE}",
        ${OFFSET_DAP},
        ${IS_MANAGEMENT},
        ${PRESSURIZE_TIME},
        ${TIME_ADVANCE},
        ${AVG_TIME_PULSE},
        ${APPLICATION_RATE},
        ${SYSTEM_EFFICIENCY},
        ${ID_SOIL},
        ${ID_FARM},
        ${INITIAL_STORAGE},
        ${SPACING_BETWEEN_LINES},
        ${SPACING_BETWEEN_PLANTS}
        );`;

    const resp = await this.api.sql({
      data: {
        sql: raw
      }
    });

    return resp;
  }
}
export { SectorRepository };
